export default "__VITE_ASSET__B8QgdtH5__"